import type { MarketSummaryTemplate } from '@simplywallst/services/lib/endpoints/getMarketSummary';
import { Bones } from '@simplywallst/ui-core';
import { SummaryTitle, SummaryWrapper } from './styled';
import { VirtualRenderer } from '@/components/VirtualRenderer/VirtualRenderer';
import useMarketSummary from '@/pages/Market/hooks/useMarketSummary';

type Props = {
  readonly title: string;
  readonly template: MarketSummaryTemplate;
};

export const Summary = ({ template, title }: Props) => {
  const { summary, isFetching } = useMarketSummary(template);

  return (
    <SummaryWrapper>
      {!isFetching ? (
        <>
          <SummaryTitle sentiment={summary.sentiment}>{title}</SummaryTitle>
          {typeof summary.virtual !== 'undefined' &&
          summary.virtual.length > 0 ? (
            <VirtualRenderer
              nodes={summary.virtual}
              options={{
                allowedNodeTypes: ['p', 'ul', 'li'],
                allowedAttributes: [],
              }}
            />
          ) : (
            summary.text
          )}
        </>
      ) : (
        <>
          <Bones maxWidth="100%" />
          <Bones maxWidth="100%" />
        </>
      )}
    </SummaryWrapper>
  );
};
